import { Box, Flex, Heading, Select, Text } from "@chakra-ui/react";
import AppDatePicker from "components/AppDatePicker";
import Sidebar3 from "components/Sidebar3";
import WelcomeSection from "components/WelcomeSection";
import { useApi } from "hooks/useApi";
import { useAuthentication } from "hooks/useAuthentication";
import { useCache } from "hooks/useCache";
import { useState } from "react";
import { Helmet } from "react-helmet";
import VerticalBarChart from "../VerticalBarChart";
import MiniStatsSection from "./MiniStatsSection";
import TaxCollectorsTable from "./TaxCollectorsTable";

const data = [
  {
    quarter: "Cocody",
    iphone: 140,
    mac: 16,
  },
  {
    quarter: "Plateau",
    iphone: 124,
    mac: 20,
  },
  {
    quarter: "Adjame",
    iphone: 112,
    mac: 20,
  },
  {
    quarter: "Yopougon",
    iphone: 118,
    mac: 24,
  },
  {
    quarter: "Abobo",
    iphone: 400,
    mac: 24,
  },
];

export default function TaxCollectorDashboardPage() {
  const { getTaxReports } = useApi();
  const {user} = useAuthentication()
  const [selectedDates, setSelectedDates] = useState<Date[]>([
    new Date(),
    new Date(),
  ]);
  const {
    data: report,
    mutate,
    isLoading,
  } = useCache("getTaxReports", () =>
    getTaxReports({
      startDate: selectedDates[0]
        .toISOString()
        .split("T")[0]
        .split("-")
        .reverse()
        .join("-"),
      endDate: selectedDates[1]
        .toISOString()
        .split("T")[0]
        .split("-")
        .reverse()
        .join("-"),
    })
  );
  const handleSetDateDifference = (event: any) => {
    const startDate = new Date(new Date().getTime() - event.target.value * 60 * 60 * 1000)
    const endDate = new Date()
    setSelectedDates([startDate, endDate]);
    mutate(
      getTaxReports({
        startDate: startDate
          .toISOString()
          .split("T")[0]
          .split("-")
          .reverse()
          .join("-"),
        endDate: endDate
          .toISOString()
          .split("T")[0]
          .split("-")
          .reverse()
          .join("-"),
      })
    );
  };
  return (
    <>
      <Helmet>
        <title>Codes QR Statistics - Origin360 Tracking and Reporting</title>
        <meta
          name="description"
          content="Monitor Code QR generation, reports, and product scans with Origin360. Get insights into counterfeit alerts and order trends for effective product tracking."
        />
      </Helmet>
      <Box bg="white" w="100%">
        <Box>
          <Flex>
            <Sidebar3 />
            <Flex
              gap="10px"
              bg="very_light_gray"
              flex={1}
              flexDirection="column"
              py="20px"
            >
              {/* welcome section */}
              <WelcomeSection />
              {!isLoading && (
                <Flex
                  gap="20px"
                  flexDirection="column"
                  alignItems="start"
                  mx={{ md: "22px", base: "0px" }}
                >
                  <Box>
                  <Heading size="xl" fontFamily="Arimo">
                    Tableau de bord collecteur
                  </Heading>
                  <Heading color={"GrayText"}  size="sm" fontFamily="Arimo">
                    Zone: {user?.user?.sub_area_name || "Non spécifiée"}
                  </Heading>
                  </Box>
                  <Flex
                    w="100%"
                    flexDirection="row"
                    justifyContent={"space-between"}
                    alignItems={"center"}
                    bg={"white"}
                    p={"10px"}
                    gap={"10px"}
                    rounded={"10px"}
                    py={"20px"}
                    flexWrap={{ base: "wrap", md: "nowrap" }}
                  >
                    <Flex
                      flexDirection="row"
                      alignItems={"center"}
                      gap={"10px"}
                    >
                      <Text fontWeight={"bold"}>Période :</Text>
                      <Select
                        width={"110px"}
                        height={"20px"}
                        onChange={handleSetDateDifference}
                        fontSize={"12px"}
                      >
                        <option value={0}>Aujourd'hui</option>
                        <option value={24}>24 heures</option>
                        <option value={48}>48 heures</option>
                        <option value={72}>72 heures</option>
                        <option value={96}>96 heures</option>
                        <option value={120}>120 heures</option>
                      </Select>
                    </Flex>
                    <Flex
                      flexDirection="row"
                      alignItems={"center"}
                      gap={"10px"}
                    >
                      <Text fontWeight={"bold"}>Sélectionner les dates :</Text>
                      <AppDatePicker
                        selectedDates={selectedDates}
                        onDateChange={(date) => {
                          console.log(date);
                          setSelectedDates(date);
                          mutate(
                            getTaxReports({
                              startDate: date[0]
                                ?.toISOString()
                                .split("T")[0]
                                .split("-")
                                .reverse()
                                .join("-"),
                              endDate: date[1]
                                ?.toISOString()
                                .split("T")[0]
                                .split("-")
                                .reverse()
                                .join("-"),
                            })
                          );
                        }}
                      />
                    </Flex>
                  </Flex>
                  <Flex w="100%" flexDirection="column">
                    {/* q r code section */}
                    <MiniStatsSection
                      data={report?.report || {}}
                      startDate={selectedDates[0]
                        .toISOString()
                        .split("T")[0]
                        .split("-")
                        .reverse()
                        .join("-")}
                      endDate={selectedDates[1]
                        ?.toISOString()
                        .split("T")[0]
                        .split("-")
                        .reverse()
                        .join("-")}
                    />
                  </Flex>
                  <Flex width={"100%"} gap={5}>
                    <Flex
                      w={{ base: "100%", md: "100%" }}
                      flexDirection="column"
                    >
                      {/* q r code section */}
                      <VerticalBarChart data={data} title="Montants collectés par jour" report={report?.report} />
                    </Flex>
                  </Flex>
                  <Flex width={"100%"} gap={5}>
                    <Flex
                      w={{ base: "100%", md: "100%" }}
                      flexDirection="column"
                    >
                      <TaxCollectorsTable />
                    </Flex>
                  </Flex>
                </Flex>
              )}
            </Flex>
          </Flex>
        </Box>
      </Box>
    </>
  );
}
